var _rect, _rect2, _circle, _circle2, _path, _path2, _path3, _rect3, _rect4, _rect5, _text, _text2, _text3, _text4, _text5, _text6, _circle3, _circle4, _text7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLangchainRag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 560,
    viewBox: "0 0 900 560",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 560,
    rx: 34,
    fill: "#0B1020"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 820,
    height: 480,
    rx: 28,
    fill: "#111827"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 142,
    r: 64,
    fill: "#22C55E",
    fillOpacity: 0.14
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 742,
    cy: 420,
    r: 86,
    fill: "#7C3AED",
    fillOpacity: 0.18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192 178C278 104 364 104 450 178C536 252 622 252 708 178",
    stroke: "#22C55E",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192 282C278 208 364 208 450 282C536 356 622 356 708 282",
    stroke: "#38BDF8",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M192 386C278 312 364 312 450 386C536 460 622 460 708 386",
    stroke: "#A78BFA",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 92,
    width: 208,
    height: 96,
    rx: 22,
    fill: "#172554",
    stroke: "#38BDF8",
    strokeOpacity: 0.55
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 346,
    y: 232,
    width: 208,
    height: 96,
    rx: 22,
    fill: "#064E3B",
    stroke: "#22C55E",
    strokeOpacity: 0.55
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 372,
    width: 208,
    height: 96,
    rx: 22,
    fill: "#312E81",
    stroke: "#A78BFA",
    strokeOpacity: 0.55
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 126,
    y: 130,
    fill: "#E0F2FE",
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: 700
  }, "Documents")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 126,
    y: 160,
    fill: "#BAE6FD",
    fontFamily: "Arial, sans-serif",
    fontSize: 16
  }, "RAG context")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 388,
    y: 270,
    fill: "#DCFCE7",
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: 700
  }, "LangChain")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 389,
    y: 300,
    fill: "#BBF7D0",
    fontFamily: "Arial, sans-serif",
    fontSize: 16
  }, "AI workflow")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 650,
    y: 410,
    fill: "#EDE9FE",
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: 700
  }, "Postgres")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 650,
    y: 440,
    fill: "#DDD6FE",
    fontFamily: "Arial, sans-serif",
    fontSize: 16
  }, "pgvector + Prisma")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 280,
    r: 96,
    stroke: "#F8FAFC",
    strokeOpacity: 0.13,
    strokeWidth: 24
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 280,
    r: 58,
    fill: "#22C55E",
    fillOpacity: 0.15,
    stroke: "#22C55E",
    strokeWidth: 4
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 402,
    y: 291,
    fill: "#F8FAFC",
    fontFamily: "Arial, sans-serif",
    fontSize: 30,
    fontWeight: 700
  }, "RAG")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangchainRag);
export default __webpack_public_path__ + "static/media/langchain-rag.527b894f71e0de1b8b84c10eba234312.svg";
export { ForwardRef as ReactComponent };